import React, { useEffect, useState } from 'react';
import { useSimasignadas, useInfoZona } from '../hooks/DashboardHook';
import ChartRadial from './RadialGrafica';

type Props = {
  filterDate: any;
  loadingGrid: boolean;
};

const SimAsigZona: React.FC<Props> = ({ filterDate, loadingGrid }) => {
  const [selectedZonaId, setSelectedZonaId] = useState<number | null>(null);
  const [sendZonaId, setSendZonaId] = useState<boolean>(!!selectedZonaId);

  const [activadas, setActivadas] = useState(0);
  const [portadas, setPortadas] = useState(0);
  const [asignadasZona, setAsignadasZona] = useState(0);
  const [totalSims, setTotalSims] = useState(0);

  const [porcActivadas, setPorcActivadas] = useState(0);
  const [porcPortadas, setPorcPortadas] = useState(0);
  const [porcAsignadas, setPorcAsignadas] = useState(0);

  const [initValues, setInitValues] = useState({
    init_date: filterDate.init_date,
    end_date: filterDate.end_date,
  });

  const { data: asignadas, loading: loadingData } = useSimasignadas(
    true,
    initValues
  );

  const { data: zona, loading: loadingZona } = useInfoZona(
    sendZonaId,
    selectedZonaId || 0,
    initValues
  );

  useEffect(() => {
    setInitValues({
      init_date: filterDate.init_date,
      end_date: filterDate.end_date,
    });
  }, [filterDate]);

  useEffect(() => {
    if (asignadas?.length && !selectedZonaId) {
      const firstId = asignadas[0]?.zona_id;
      if (firstId > 0) {
        setSelectedZonaId(firstId);
        setSendZonaId(true);
      }
    }
  }, [asignadas, selectedZonaId]);

  useEffect(() => {
    if (zona?.cantidad_stocks !== undefined) {
      sessionStorage.setItem('zonaData', JSON.stringify(zona));

      const total = zona.cantidad_stocks ?? 0;
      if (total === null || total === undefined) return;

      const activadasVal = zona.totalActivadas ?? 0;
      const portadasVal = zona.totalPortadas ?? 0;
      const asignadasVal = zona.totalAsignadas ?? 0;

      setTotalSims(total);
      setActivadas(activadasVal);
      setPortadas(portadasVal);
      setAsignadasZona(asignadasVal);

      const pct = (v: number) => (total > 0 ? (v / total) * 100 : 0);
      setPorcActivadas(pct(activadasVal));
      setPorcPortadas(pct(portadasVal));
      setPorcAsignadas(pct(asignadasVal));
    }
  }, [zona]);

  useEffect(() => {
    const storedZona = sessionStorage.getItem('zonaData');
    if (storedZona && !zona) {
      const parsed = JSON.parse(storedZona);
      setTotalSims(parsed.cantidad_stocks ?? 0);
      setActivadas(parsed.totalActivadas ?? 0);
      setPortadas(parsed.totalPortadas ?? 0);
      setAsignadasZona(parsed.totalAsignadas ?? 0);

      const total = parsed.cantidad_stocks ?? 0;
      const pct = (v: number) => (total > 0 ? (v / total) * 100 : 0);
      setPorcActivadas(pct(parsed.totalActivadas ?? 0));
      setPorcPortadas(pct(parsed.totalPortadas ?? 0));
      setPorcAsignadas(pct(parsed.totalAsignadas ?? 0));
    }
  }, []);

  const loading =
    loadingGrid ||
    loadingData ||
    loadingZona ||
    (!zona && !sessionStorage.getItem('zonaData'));

  return (
    <div className="card card-flush w-650px h-400px ms-2">
      <div className="card-header pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-dark fs-3">
            Monitoreo de SIM asignadas
          </span>
          <span className="text-gray-400 mt-1 fw-semibold fs-6">
            Unidades de {asignadas?.[0]?.zona_nombre ?? '...'}
          </span>
        </h3>
      </div>

      <div className="card-body pt-0">
        {loading ? (
          <div className="d-flex align-items-center">
            <div className="text-muted text-center fs-6 w-100 m-5">
              <span className="indicator-progress" style={{ display: 'block' }}>
                Espere por favor...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-12 mt-9">
                <div className="row">
                  <div className="col">
                    <ChartRadial
                      value={porcAsignadas}
                      total={asignadasZona}
                      operation="Asignadas"
                      color="#0d6efd"
                      height={150}
                    />
                  </div>
                  <div className="col">
                    <ChartRadial
                      value={porcActivadas}
                      total={activadas}
                      operation="Activadas"
                      color="#7A4EEA"
                      height={150}
                    />
                  </div>
                  <div className="col">
                    <ChartRadial
                      value={porcPortadas}
                      total={portadas}
                      operation="Portadas"
                      color="#F26522"
                      height={150}
                    />
                  </div>
                </div>
              </div>
              <div className="text-center mt-6 fw-bold fs-3">
                Total: <span className="fw-bolder">{totalSims}</span> unidades
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { SimAsigZona };
